import { render, staticRenderFns } from "./FullTour.vue?vue&type=template&id=2a518f13&"
import script from "./FullTour.vue?vue&type=script&lang=js&"
export * from "./FullTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports